module.exports = __webpack_public_path__ + "static/media/book mark 4.a3236fc5.jpg";